const getImageFitSize = (
  containerWidth,
  containerHeight,
  imageWidth,
  imageHeight,
) => {
  const containerAspectRatio = containerWidth / containerHeight;
  const imageAspectRatio = imageWidth / imageHeight;

  if (containerAspectRatio < imageAspectRatio) {
    const widthRatio = containerWidth / imageWidth;
    return { width: containerWidth, height: imageHeight * widthRatio };
  }
  const heightRatio = containerHeight / imageHeight;

  return { width: imageWidth * heightRatio, height: containerHeight };
};

export default getImageFitSize;
